<hr>
<form [formGroup]="parametroForm" (ngSubmit)="onSubmit()">
    <input hidden formControlName="id">
    
    <!-- Primeira Linha: Descrição, Projeto, Feira e Status Orçamento -->
    <div class="row align-items-center mb-3" style="justify-content: center;">
        <div class="col-lg-3">
            <div class="mb-3">
                <label for="descricao" class="form-label">Descrição<span style="color: red;"> *</span></label>
                <input
                    id="descricao"
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="descricao"
                    placeholder="Descrição do orçamento"
                    [ngClass]="{
                        'is-invalid':
                        parametroForm.controls.descricao.errors &&
                        parametroForm.get('descricao')?.touched,
                    }"
                >
                <div class="invalid-feedback" *ngIf="parametroForm.controls.descricao.errors && parametroForm.get('descricao')?.touched">
                    O campo Descrição é obrigatório.
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="mb-3">
                <label for="projetoId" class="form-label">Projeto</label>
                
                <!-- Container do select com busca integrada -->
                <div class="position-relative">
                    <div class="dropdown" [class.show]="dropdownProjetoAberto">
                        <!-- Input de busca que simula um select -->
                        <input
                            type="text"
                            class="form-control form-control-sm dropdown-toggle"
                            placeholder="Selecione um projeto..."
                            [(ngModel)]="buscaProjeto"
                            (input)="buscaProjetoDebounce$.next(buscaProjeto)"
                            (focus)="abrirDropdownProjeto()"
                            (blur)="fecharDropdownProjeto()"
                            [ngModelOptions]="{standalone: true}"
                            autocomplete="off"
                        >
                        
                        <!-- Dropdown com opções -->
                        <div 
                            class="dropdown-menu w-100" 
                            [class.show]="dropdownProjetoAberto" 
                            style="max-height: 200px; overflow-y: auto;"
                            (scroll)="onScrollProjetos($event)"
                        >
                            <div *ngIf="(projetosFiltrados || []).length === 0 && !projetoPaginas?.carregandoMais" class="dropdown-item-text text-muted">
                                Nenhum projeto encontrado
                            </div>
                            <a 
                                *ngFor="let projeto of projetosFiltrados || []" 
                                class="dropdown-item" 
                                href="#"
                                (mousedown)="selecionarProjeto(projeto)"
                            >
                                <strong>{{ projeto.descricao }}</strong> - {{ projeto.cliente }}
                            </a>
                            <div *ngIf="projetoPaginas?.carregandoMais" class="dropdown-item-text text-center text-muted">
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                                Carregando...
                            </div>
                        </div>
                    </div>
                    
                    <!-- Hidden select para manter a validação do formulário -->
                    <select
                        id="projetoId"
                        class="d-none"
                        formControlName="projetoId"
                    >
                        <option value="">Selecione um projeto</option>
                        <option *ngFor="let projeto of projetosFiltrados || []" [value]="projeto.id">
                            {{ projeto.descricao }} - {{ projeto.cliente }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="mb-3">
                <label for="feira" class="form-label">Feira<span style="color: red;"> *</span></label>
                <input
                    id="feira"
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="feira"
                    placeholder="Nome da feira"
                    [ngClass]="{
                        'is-invalid':
                        parametroForm.controls.feira.errors &&
                        parametroForm.get('feira')?.touched,
                    }"
                >
                <div class="invalid-feedback" *ngIf="parametroForm.controls.feira.errors && parametroForm.get('feira')?.touched">
                    O campo Feira é obrigatório.
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="mb-3">
                <label for="statusOrcamento" class="form-label">Status Orçamento</label>
                <select
                    id="statusOrcamento"
                    class="form-select form-select-sm"
                    formControlName="statusOrcamento"
                >
                    <option [ngValue]="0">Orçando</option>
                    <option [ngValue]="1">Aprovado</option>
                    <option [ngValue]="2">Reprovado</option>
                </select>
            </div>
        </div>
    </div>
    
    <!-- Segunda Linha: Comprimento, Largura e Total -->
    <div class="row align-items-center mb-3" style="justify-content: center;">
        <div class="col-lg-2">
            <div class="mb-3">
                <label for="comprimento" class="form-label">Comprimento</label>
                <input formControlName="comprimento" mask="separator.2" thousandSeparator="." decimalMarker=","
                    [dropSpecialCharacters]="false" type="text" class="form-control form-control-sm" id="comprimento"
                    (input)="calcularMetroQuadrado()" [ngClass]="{
                    'is-invalid':
                    parametroForm.controls.comprimento.errors &&
                    parametroForm.get('comprimento')?.touched,
                  }">
                <div class="invalid-feedback" *ngIf="parametroForm.controls.comprimento.errors">
                    O campo é obrigatório.
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="mb-3">
                <label for="largura" class="form-label">Largura</label>
                <input formControlName="largura" type="text" class="form-control form-control-sm" id="largura"
                    (input)="calcularMetroQuadrado()" [ngClass]="{
                    'is-invalid':
                    parametroForm.controls.largura.errors &&
                    parametroForm.get('largura')?.touched,
                  }">
                <div class="invalid-feedback" *ngIf="parametroForm.controls.largura.errors">
                    O campo é obrigatório.
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="mb-3">
                <label class="form-label">Total</label>
                <h5 class="mt-2">{{ totalMetrosQuadrados | number:'1.2-2' }}</h5>
            </div>
        </div>
    </div>
    <div class="row align-items-center" style="justify-content: center;">
        <div class="col-lg-2">
            <div class="mb-3">
                <label for="comprimento" class="form-label">Comprimento Sobrepor</label>
                <input formControlName="comprimentoSobrepor" mask="separator.2" thousandSeparator="." decimalMarker=","
                    [dropSpecialCharacters]="false" type="text" class="form-control form-control-sm" id="comprimento"
                    (input)="calcularMetroQuadradoSobrepor()">
            </div>
        </div>
        <div class="col-lg-2">
            <div class="mb-3">
                <label for="largura" class="form-label">Langura <br> Sobrepor</label>
                <input formControlName="larguraSobrepor" type="text" class="form-control form-control-sm" id="largura"
                    (input)="calcularMetroQuadradoSobrepor()">
            </div>
        </div>
        <div for="totalMetrosQuadrados" class="col-lg-2">
            Total<h4>{{ totalMetrosSobrepor | number:'1.2-2' }}</h4>
        </div>
    </div>

    <hr>

    <div class="row" style="display: flex; justify-content:space-between;">
        <h5 class="text-center m-3">Preencha os valores percentuais abaixo</h5>
        <div class="col-6">

            <div class="row mb-4">
                <label for="percentualImpostoFaturaIsentoIss" class="col-sm-6 col-form-label">Imposto fatura insento
                    ISS:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualImpostoFaturaIsentoIss" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualImpostoFaturaIsentoIss" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualImpostoFaturaIsentoIss.errors &&
                            parametroForm.get('percentualImpostoFaturaIsentoIss')?.touched,
                          }">
                    <div class="invalid-feedback"
                        *ngIf="parametroForm.controls.percentualImpostoFaturaIsentoIss.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <label for="percentualCustoOperacional" class="col-sm-6 col-form-label">Custo operacional:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualCustoOperacional" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualCustoOperacional" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualCustoOperacional.errors &&
                            parametroForm.get('percentualCustoOperacional')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualCustoOperacional.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <label for="percentualMargemDeLucro" class="col-sm-6 col-form-label">Margem de lucro:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualMargemDeLucro" mask="separator.2" suffix="%" thousandSeparator="."
                        decimalMarker="," [max]="100" type="text" class="form-control form-control-sm"
                        id="percentualMargemDeLucro" placeholder="%" spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualMargemDeLucro.errors &&
                            parametroForm.get('percentualMargemDeLucro')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualMargemDeLucro.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <label for="percentualVariacaoOrcamento" class="col-sm-6 col-form-label">Variação de orcamento:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualVariacaoOrcamento" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualVariacaoOrcamento" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualVariacaoOrcamento.errors &&
                            parametroForm.get('percentualVariacaoOrcamento')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualVariacaoOrcamento.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">


            <div class="row mb-4">
                <label for="percentualComissaoVendas" class="col-sm-6 col-form-label">Commisão vendas:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualComissaoVendas" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualComissaoVendas" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualComissaoVendas.errors &&
                            parametroForm.get('percentualComissaoVendas')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualComissaoVendas.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <label for="percentualStudioArquiteto" class="col-sm-6 col-form-label">Comissão Arquiteto:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualStudioArquiteto" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualStudioArquiteto" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualStudioArquiteto.errors &&
                            parametroForm.get('percentualStudioArquiteto')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualStudioArquiteto.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <label for="percentualMargemNegociacao" class="col-sm-6 col-form-label">Margem negociação:</label>
                <div class="col-sm-3">
                    <input formControlName="percentualMargemNegociacao" mask="separator.2" suffix="%"
                        thousandSeparator="." decimalMarker="," [max]="100" type="text"
                        class="form-control form-control-sm" id="percentualMargemNegociacao" placeholder="%"
                        spellcheck="false" data-ms-editor="true" [ngClass]="{
                            'is-invalid':
                            parametroForm.controls.percentualMargemNegociacao.errors &&
                            parametroForm.get('percentualMargemNegociacao')?.touched,
                          }">
                    <div class="invalid-feedback" *ngIf="parametroForm.controls.percentualMargemNegociacao.errors">
                        O campo é obrigatório.
                    </div>
                </div>
            </div>
        </div>

    </div>
    <hr>
    <div class="row mt-4 mb-3">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <button (click)="voltar()" type="button" class="btn btn-secondary waves-effect">
                        <i class="fas fa-arrow-left me-2"></i> Voltar
                    </button>
                </div>
                <div class="d-flex align-items-center">
                    <button type="submit" class="btn btn-success waves-effect waves-light me-2">
                        <i class="fas fa-save me-2"></i> Salvar
                    </button>
                    <!-- <button (click)="baixarArquivoExcel()" type="button" class="btn btn-info waves-effect waves-light" [disabled]="!orcamentoId || orcamentoId === '' || orcamentoId === 'novo'">
                        <i class="mdi mdi-download me-2"></i> Download Excel
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</form>
